module.exports = __webpack_public_path__ + "static/6-setup-multifactor-authentication-428cb92aed1c022f2ab01189a5f2e6e9.jpg";